export default "__VITE_ASSET__BjUFGQRQ__"